import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import { BrowserRouter as Router } from "react-router-dom";
import AppErrorBoundary from "./errorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <Router>
        <AppErrorBoundary>
          <App />
        </AppErrorBoundary>
      </Router>
    </React.StrictMode>
  </Provider>
);


reportWebVitals();
